import MainBannerComponent from "../../Components/homePage/MainBannerComponent/MainBannerComponent";
import ProfileNavbar from "../../Components/ProfileNavbar/ProfileNavbar";

export default function HomePage() {

  return (
    <>
      <ProfileNavbar/>
      <MainBannerComponent/>
    </>
  );
}
